import attendanceModeService from "@/services/attendanceMode";
import router from "../../router/index";

const getDefaultState = () => {
  return {
    attendanceMode: [],
    attendanceModes: null,
    attendanceCodes: [],
    isAvailable: true,
    loadingStatus: false,
  };
};

export const state = getDefaultState();

export const actions = {
  fetchAttendanceModes({ commit }, payload) {
    commit("setLoadingStatus", false);
    return new Promise((resolve, reject) => {
      attendanceModeService
        .getAttendanceModes(payload)
        .then((data) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  addAttendanceMode({ commit }, payload) {
    return new Promise((resolve, reject) => {
      attendanceModeService
        .addAttendanceMode(payload)
        .then((data) => {
          resolve(data);
          commit("setAddAttendanceMode", data.data);
          this._vm.$toast.success(data.message);
          router.push("/attendance-modes");
        })
        .catch((err) => {
          reject(err);
          this._vm.$toast.error(
            err.data.message ? err.data.message : err.data.message
          );
        });
    });
  },

  checkDuplicateName({ commit }, payload) {
    return new Promise((resolve, reject) => {
      attendanceModeService
        .checkDuplicateName(payload)
        .then((data) => {
          resolve(data);
          commit("setIsAvailable", data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  editAttendanceMode({ commit }, payload) {
    commit("setLoadingStatus", false);
    return new Promise((resolve, reject) => {
      attendanceModeService
        .editMode(payload)
        .then((data) => {
          this._vm.$toast.success(
            data.message
          );
          router.push("/attendance-modes");
          resolve(data);
        })
        .catch((err) => {
          reject(err);
          this._vm.$toast.error(
            err.data.message ? err.data.message : err.data.message
          );
        });
    });
  },

  fetchAttendanceCodes({ commit }, payload) {
    commit("setLoadingStatus", false);
    return new Promise((resolve, reject) => {
      attendanceModeService
        .getAttendanceCodes(payload)
        .then((data) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
          this._vm.$toast.error(
            err.data.message ? err.data.message : err.data.message
          );
        });
    });
  },

  addReason({ commit }, payload) {
    commit("setLoadingStatus", false);
    return new Promise((resolve, reject) => {
      attendanceModeService
        .addReason(payload)
        .then((data) => {
          this._vm.$toast.success(data.message);
          router.push("/attendance-modes");
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  editReason({ commit }, payload) {
    commit("setLoadingStatus", false);
    return new Promise((resolve, reject) => {
      attendanceModeService
        .editReason(payload)
        .then((data) => {
          this._vm.$toast.success(data.message);
          router.push("/attendance-modes");
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  deleteModeOrReason({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      attendanceModeService
        .deleteModeOrReason(payload)
        .then((data) => {
          dispatch("fetchAttendanceModes");
          this._vm.$toast.success(data.message);
          resolve(data);
        })
        .catch((err) => {
          reject(err);
          this._vm.$toast.error(
            err.data.message ? err.data.message : err.data.message
          );
        });
    });
  },
  fetchAttendanceModeById({ commit }, id) {
    commit("setLoadingStatus",false);
    return new Promise((resolve , reject ) => {
      attendanceModeService
        .getAttendanceModeById(id)
        .then((data) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
          err.status != 401 && !err.data.otp_error && this._vm.$toast.error(err.data.message);
        });
    });
},
};

export const mutations = {
  setAddAttendanceMode(state, payload) {
    state.attendanceMode = payload;
  },

  setAttendanceModes(state, payload) {
    state.attendanceModes = payload;
  },

  setAttendanceCodes(state, payload) {
    state.attendanceCodes = payload;
  },
  setLoadingStatus(state, loading) {
    state.loadingStatus = loading;
  },
  setIsAvailable(state, payload) {
    state.isAvailable = payload;
  },
};

export const getters = {
  getAddAttendanceMode(state) {
    return state.attendanceMode;
  },

  getAttendanceModes(state) {
    return state.attendanceModes;
  },

  getAttendanceCodes(state) {
    return state.attendanceCodes;
  },
  getIsAvailable(state) {
    return state.isAvailable;
  },
};
